import LeftLeafSVG from '../../../../../../icons/LeftLeafSVG'
import RightLeafSVG from '../../../../../../icons/RightLeafSVG'
import { useBottomSheet } from '../../../../../../state-management/contexts/BottomSheetContext'
import { EliteLandingPageKnowWhyContent } from '../../../../../BottomSheetComponents/EliteLandingPageKnowWhyContent'
import { trackEvent } from '../../../../../../utils/appBridge'
import { EventNames } from '../../../../../../types/misc.types'
import { formatNumberWithoutCurrency } from '../../../../../../utils/utils'
import { GROUPED_STATIC_TEXT_ROLE } from '../../../../../ui-components/NameValueTableRow'
import { useEliteBuyCtaExtras } from '../../../../EliteBuyCtaExtrasContext'

export const BrokePricing = ({
  screenType = 'ELITE_LANDING_PAGE_1L',
  amount = 0
}: {
  screenType?: string
  amount?: number
}) => {
  const eliteBuyCtaExtras = useEliteBuyCtaExtras()
  const { openBottomSheet, closeBottomSheet } = useBottomSheet()
  const formattedAmount = formatNumberWithoutCurrency(amount ?? 0)

  const handleKnowHowClick = () => {
    trackEvent({
      eventName: EventNames.UserClicked,
      payload: {
        ...eliteBuyCtaExtras,
        eventId: 'KnowHow_Clicked',
        ScreenName: screenType,
        buttonLabel: 'Know How'
      }
    })
    openBottomSheet(<EliteLandingPageKnowWhyContent onDismiss={closeBottomSheet} />)
  }

  return (
    <div>
      <div
        role={GROUPED_STATIC_TEXT_ROLE}
        aria-label='Get institutional-grade advice and earn up to 2-4% higher returns'
        className='text-lg font-medium text-grey10 text-center'
      >
        <span aria-hidden='true'>
          Get institutional-grade advice and earn up to{' '}
          <span className='text-[#992E00] font-bold'>2-4% higher returns</span>
        </span>
      </div>
      <button
        type='button'
        onClick={handleKnowHowClick}
        aria-label='Know How'
        aria-description='Double tap to learn how Elite delivers higher returns'
        className='flex font-medium flex-row justify-center items-center max-w-[80px] text-[#722200] text-xs bg-[#FFF2DF] rounded-lg mx-auto mt-3 py-2 cursor-pointer border-none'
      >
        Know How
      </button>
      <div
        role={GROUPED_STATIC_TEXT_ROLE}
        aria-label={`At minimal cost of just ₹${formattedAmount} per year + GST`}
        className='flex flex-row items-center justify-center gap-4 mt-10'
      >
        <span aria-hidden='true'>
          <LeftLeafSVG width={32} height={56} fill={'#23232326'} />
        </span>
        <div className='flex flex-col items-center justify-center' aria-hidden='true'>
          <div className='text-sm text-grey40 mb-1'>At minimal cost of just</div>
          <div className='text-[30px] text-grey10 font-medium leading-[1]'>
            ₹{formattedAmount}/yr + GST
          </div>
        </div>
        <span aria-hidden='true'>
          <RightLeafSVG width={32} height={56} fill={'#23232326'} />
        </span>
      </div>
      <div
        role={GROUPED_STATIC_TEXT_ROLE}
        aria-label='Special price for next 10k members'
        className='text-sm text-orange10 text-center mt-3 font-medium'
      >
        <span aria-hidden='true'>✦ Special price for next 10k members ✦</span>
      </div>
    </div>
  )
}
